import { render, staticRenderFns } from "./MessageExcerpt.html?vue&type=template&id=01415be1&scoped=true&"
import script from "./MessageExcerpt.js?vue&type=script&lang=js&"
export * from "./MessageExcerpt.js?vue&type=script&lang=js&"
import style0 from "./MessageExcerpt.scss?vue&type=style&index=0&id=01415be1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01415be1",
  null
  
)

export default component.exports